import {DatabaseCode, toDatabaseCode} from "./database-code";

export type SystemProcessStatus = DatabaseCode;

const queued: SystemProcessStatus = {
  code: "QUEUED",
  displayValue: {
    id: "common.entity.systemprocesstatus.queued",
    defaultMessage: "Queued",
  },
};

const running: SystemProcessStatus = {
  code: "RUNNING",
  displayValue: {
    id: "common.entity.systemprocesstatus.running",
    defaultMessage: "Running",
  },
};

const succeeded: SystemProcessStatus = {
  code: "SUCCEEDED",
  displayValue: {
    id: "common.entity.systemprocesstatus.succeeded",
    defaultMessage: "Succeeded",
  },
};

const partial: SystemProcessStatus = {
  code: "PARTIAL",
  displayValue: {
    id: "common.entity.systemprocesstatus.partial",
    defaultMessage: "Partial",
  },
};

const failed: SystemProcessStatus = {
  code: "FAILED",
  displayValue: {
    id: "common.entity.systemprocesstatus.failed",
    defaultMessage: "Failed",
  },
};

const canceled: SystemProcessStatus = {
  code: "CANCELED",
  displayValue: {
    id: "common.entity.systemprocesstatus.canceled",
    defaultMessage: "Canceled",
  },
};

export const systemProcessStatus = {
  queued,
  running,
  succeeded,
  partial,
  failed,
  canceled,
};

export const systemProcessStatuses = Object.values(systemProcessStatus);

export const toSystemProcessStatus = (code: string): SystemProcessStatus =>
  toDatabaseCode(code, systemProcessStatuses);

export const toSystemProcessStatusSafely = (
  code: string | undefined
): SystemProcessStatus | undefined =>
  code ? toDatabaseCode(code, systemProcessStatuses) : undefined;
